<script>
import LayoutMember from '@layouts/LayoutMember'

export default {
  components: { LayoutMember },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  methods: {
    handleContact() {
      const vnodes = []

      if (this.order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${this.order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {this.order.merchant.email}
      </a>
      )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${this.order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {this.order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(messageElement, this.$t('global.CONTACT_PREFIX', { name: this.order.merchant.name }/* 聯繫{name} */), {
        distinguishCancelAndClose: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
        ),
        confirmButtonClass: 'button is-primary is-rounded',
      })
    },
    handleCancel() {
      const vnodes = [];

      if (this.order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${this.order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {this.order.merchant.email}
      </a>
      )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${this.order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {this.order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(
        messageElement,
        this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_TITLE',
          {
            actionName: this.$t(
              `product.prepaid.ORDER_CANCEL`
            ),
            merchantName: this.order.merchant.name,
          } /* 取消預訂請聯繫{merchantName} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    orderStatusAlias(orderStatus) {
      const statusAliasMap = [
        'cancel',
        'paid',
        'unpaid',
      ];

      return statusAliasMap[orderStatus]
    },
  },
}
</script>

<template>
  <LayoutMember>
    <template v-if="!isNullOrder">
      <div class="booking-section">
        <div class="level subsection is-tab-style">
          <div class="level-left booking-section__title">
            <router-link
              :to="{
                name: 'member-order',
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              class="is-link-black"
            >
              <BaseIcon name="angle-left" style="margin-right: 0.5rem"/>
              <span class="is-size-6">{{ $t('global.BACK_LIST'/*回列表*/) }}</span>
            </router-link>
          </div>
          <div class="level-right buttons is-tab-style">
            <router-link
              class="button is-tab-style"
              :class="{ 'is-active': $route.name === 'member-prepaid-history' }"
              :to="{ name: 'member-prepaid-history', params: { orderKey: order.id }, query: { language: $route.query.language, merchant: $route.query.merchant } }"
            >
              {{$t('global.HISTORY'/*使用歷程*/)}}
            </router-link>
            <router-link
              class="button is-tab-style"
              :class="{ 'is-active': $route.name === 'member-prepaid-item' }"
              :to="{ name: 'member-prepaid-item', params: { orderKey: order.id }, query: { language: $route.query.language, merchant: $route.query.merchant } }"
            >
              {{$t('global.MEMBER_ORDER_DETAIL'/*使用歷程*/)}}
            </router-link>
            <router-link
              class="button is-tab-style"
              :class="{ 'is-active': $route.name === 'member-prepaid-applicable' }"
              :to="{ name: 'member-prepaid-applicable', params: { orderKey: order.id }, query: { language: $route.query.language, merchant: $route.query.merchant } }"
            >
              {{$t('global.PREPAID_APPLICABLE'/*適用項目*/)}}
            </router-link>
            <router-link
              class="button is-tab-style"
              :class="{ 'is-active': $route.name === 'member-prepaid-description' }"
              :to="{ name: 'member-prepaid-description', params: { orderKey: order.id }, query: { language: $route.query.language, merchant: $route.query.merchant } }"
            >
              {{$t('global.PREPAID_DESCRIPTION'/*方案說明*/)}}
            </router-link>
          </div>
        </div>
        <div class="subsection product-wrapper">
          <slot></slot>
        </div>
        <div class="subsection">
          <div v-if="orderStatusAlias(order.status) === 'unpaid'" class="buttons">
            <template>
              <router-link
                class="button is-rounded is-fullwidth is-primary"
                :to="{
                name: 'booking-prepaid-unpaid-checkout',
                params: {
                  merchantAlias: order.merchant.alias,
                  prepaidId: order.prepaid.alias,
                  orderKey: order.id,
                },
                query: {
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}
              </router-link>
            </template>
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-primary"
              :to="{
              name: 'member-prepaid',
              query: {
                merchant: $route.query.merchant,
                language: $route.query.language,
              },
            }"
            >
              {{ $t('global.BACK_LIST'/*回列表頁*/) }}
            </router-link>
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-black"
              :to="{
              name: 'booking-prepaid-item',
              params: {
                merchantAlias: order.merchant.alias,
                prepaidAlias: order.prepaid.alias,
              },
              query: {
                language: $route.query.language,
              },
            }"
            >
              {{ $t(`product.prepaid.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
            </router-link>
            <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
            <b-button
              type="is-black"
              rounded
              class="button is-rounded is-outlined is-fullwidth"
              @click="handleCancel"
            >{{ $t(`product.prepaid.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
          </div>
          <div v-if="orderStatusAlias(order.status) === 'paid'" class="buttons">
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-primary"
              :to="{
              name: 'member-prepaid',
              query: {
                merchant: $route.query.merchant,
                language: $route.query.language,
              },
            }"
            >
              {{ $t('global.BACK_LIST'/*回列表頁*/) }}
            </router-link>
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-black"
              :to="{
              name: 'booking-prepaid-item',
              params: {
                merchantAlias: order.merchant.alias,
                prepaidAlias: order.prepaid.alias,
              },
              query: {
                language: $route.query.language,
              },
            }"
            >
              {{ $t('global.BUY_AGAIN'/*再次購買*/) }}
            </router-link>
            <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
            <b-button
              type="is-black"
              rounded
              class="button is-rounded is-outlined is-fullwidth"
              @click="handleCancel"
            >
              {{ $t(`product.prepaid.ORDER_CANCEL`/* 取消預訂 */) }}
            </b-button>
          </div>
          <div v-if="orderStatusAlias(order.status) === 'cancel'" class="buttons">
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-primary"
              :to="{
              name: 'member-prepaid',
              query: {
                merchant: $route.query.merchant,
                language: $route.query.language,
              },
            }"
            >
              {{ $t('global.BACK_LIST'/*回列表頁*/) }}
            </router-link>
            <router-link
              class="button is-rounded is-outlined is-fullwidth is-black"
              :to="{
              name: 'booking-prepaid-item',
              params: {
                merchantAlias: order.merchant.alias,
                prepaidAlias: order.prepaid.alias,
              },
              query: {
                language: $route.query.language,
              },
            }"
            >
              {{ $t(`product.prepaid.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="booking-section--outside">
        <b-button
          type="is-black"
          rounded
          outlined
          class="is-fullwidth"
          @click="handleContact"
        >{{ $t('global.CONTACT_MERCHANT'/*聯絡商家*/) }}</b-button>
      </div>
    </template>
    <template v-else>
      <div class="defaultBox">
        <img alt="merchant default" class="defaultBox__image" src="@assets/images/information_default.png" />
        <h3 class="defaultBox__text">
          {{$t('global.NOT_FOUND_PREFIX', { text: $t('global.ORDER') } /*找不到訂單*/)}}
        </h3>
      </div>
      <router-link
        class="button is-primary is-rounded is-fullwidth"
        :to="{ name: 'member-prepaid', query: { language: $route.query.language, merchant: $route.query.merchant } }"
      >
        回列表
      </router-link>
    </template>
  </LayoutMember>
</template>
